module.exports = __webpack_public_path__ + "static/media/icon_ing.17601f45.svg";